import './app.scss';
import './components/navigation'
import './components/text'
import './components/groupInfo'
import './components/programme/index.jsx'
import './components/blog'



// WEBPACK FOOTER //
// ./src/app.js